import { render, staticRenderFns } from "./dynamic-group-patients-page.vue?vue&type=template&id=f0407558&scoped=true"
import script from "./dynamic-group-patients-page.vue?vue&type=script&lang=js"
export * from "./dynamic-group-patients-page.vue?vue&type=script&lang=js"
import style0 from "./dynamic-group-patients-page.vue?vue&type=style&index=0&id=f0407558&prod&scoped=true&lang=css"
import style1 from "./dynamic-group-patients-page.vue?vue&type=style&index=1&id=f0407558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0407558",
  null
  
)

export default component.exports